import { useRef, useCallback } from 'react';
import { useTracking } from '@edreamsodigeo/frontend-core';

import { RESULTS_CATEGORY } from '../../providers/TrackingProviders';
import { usePerformedSearchRequest } from '../../providers/SearchRequestProvider';
import { useHighlightedItinerariesQuery } from '../../providers/FilteredItinerariesProvider';

import getPriceLabel from './getPriceLabel';
const isOneWay = (tripType) => tripType && tripType === 'ONE_WAY';

function getRecommendPosition({ recommended }) {
  return `rc:${recommended?.priceSortingPosition ?? 'NA'}`;
}

const createOdiItineraryLabel = ({
  highlightedItineraries,
  selectedItinerary,
  tripType,
}) => {
  let isLoadOrSelectionLabel = 'l';
  if (selectedItinerary) {
    isLoadOrSelectionLabel = 's';
    highlightedItineraries.cheapest = selectedItinerary;
  }

  return [
    `${isLoadOrSelectionLabel}`,
    `sc:NA`, //sc

    `${getRecommendPosition(highlightedItineraries)}`, // rc
    `ml:1`, // ml
    `${getPriceLabel(highlightedItineraries)}`, // pr

    `bg:NA-NA`, // bg
    `dr:NA-NA`, // dr ask when duration is FAST - SLOW
    `sd:NA-NA`, // sd
    `${isOneWay(tripType) ? 'sr:OW-OW' : 'sr:NA-NA'}`, // sr
    `ar:NA-NA`, // ar ask when has a main airport
    `st:NA-NA`, // st
  ].join('_');
};

const useOdiItineraryTracking = () => {
  const { trackEvent } = useTracking();
  const { tripType } = usePerformedSearchRequest() || {};
  const ref = useRef();
  const { data: highlightedItineraries } = useHighlightedItinerariesQuery();
  if (!ref.current && highlightedItineraries) {
    ref.current = highlightedItineraries;
  }

  return useCallback(
    (selectedItinerary = null) => {
      trackEvent({
        category: RESULTS_CATEGORY,
        action: 'odi',
        label: createOdiItineraryLabel({
          tripType,
          highlightedItineraries: ref.current,
          selectedItinerary,
        }),
      });
    },
    [trackEvent, tripType, ref]
  );
};

export default useOdiItineraryTracking;
